angular.module('FlexyBeautyApp.services')
    .factory('UboStatus', ['gettextCatalog', function (gettextCatalog) {
        return {
            VALIDATING: {
                id: 'validating',
                label: gettextCatalog.getString("Déclaration En cours")
            },
            VALIDATED: {
                id: 'validated',
                label: gettextCatalog.getString("Déclaration validée")
            },
            REFUSED: {
                id: 'refused',
                label: gettextCatalog.getString("Déclaration refusée")
            },
            INCOMPLETE: {
                id: 'incomplete',
                label: gettextCatalog.getString("Déclaration incomplète")
            },
            NOTCREATED: {
                id: 'notCreated',
                label: gettextCatalog.getString("Déclaration n'a pas été transmise à MangoPay")
            },
        };
    }]);



// WEBPACK FOOTER //
// ./js/services/views/UboStatus.js